import { render, staticRenderFns } from "./kChart.vue?vue&type=template&id=6e449b30&scoped=true&"
import script from "./kChart.vue?vue&type=script&lang=js&"
export * from "./kChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e449b30",
  null
  
)

export default component.exports